/* eslint-disable */
import { CSSProperties, MutableRefObject, useCallback, useMemo, useState, useEffect } from 'react'
import { Currency, CurrencyAmount, Token } from '@noahswap/sdk'
import { Text, useModal } from '@noahswap/uikit'
import styled from 'styled-components'
import { FixedSizeList } from 'react-window'
import { wrappedCurrency } from 'utils/wrappedCurrency'
import { LightGreyCard } from 'components/Card'
import QuestionHelper from 'components/QuestionHelper'
import { useTranslation } from '@noahswap/localization'
import useActiveWeb3React from 'hooks/useActiveWeb3React'
import { useWeb3React } from '@noahswap/wagmi'
import useNativeCurrency from 'hooks/useNativeCurrency'
import { useCombinedActiveList } from '../../state/lists/hooks'
// import { useDefaultList } from '../../state/lists/hooks'
import { useCurrencyBalance } from '../../state/wallet/hooks'
import { useIsUserAddedToken } from '../../hooks/Tokens'
import Column from '../Layout/Column'
import { RowFixed, RowBetween } from '../Layout/Row'
import { CurrencyLogo } from '../Logo'
import CircleLoader from '../Loader/CircleLoader'
import { isTokenOnList } from '../../utils'
import ImportRow from './ImportRow'
import TipsModal from './TipsModal'

function currencyKey(currency: Currency): string {
  return currency?.isToken ? currency.address : currency?.isNative ? currency.symbol : ''
}

const StyledBalanceText = styled(Text)`
  white-space: nowrap;
  overflow: hidden;
  max-width: 5rem;
  text-overflow: ellipsis;
`

const FixedContentRow = styled.div`
  padding: 4px 20px;
  height: 56px;
  display: grid;
  grid-gap: 16px;
  align-items: center;
`

function Balance({ balance }: { balance: CurrencyAmount<Currency> }) {
  return <StyledBalanceText title={balance.toExact()}>{balance.toSignificant(4)}</StyledBalanceText>
}

const MenuItem = styled(RowBetween)<{ disabled: boolean; selected: boolean }>`
  padding: 4px 20px;
  height: 56px;
  display: grid;
  grid-template-columns: auto minmax(auto, 1fr) minmax(0, 72px);
  grid-gap: 8px;
  cursor: ${({ disabled }) => !disabled && 'pointer'};
  pointer-events: ${({ disabled }) => disabled && 'none'};
  :hover {
    background-color: ${({ theme, disabled }) => !disabled && theme.colors.background};
  }
  opacity: ${({ disabled, selected }) => (disabled || selected ? 0.5 : 1)};
`

function CurrencyRow({
  currency,
  onSelect,
  isSelected,
  otherSelected,
  style,
}: {
  currency: Currency
  onSelect: () => void
  isSelected: boolean
  otherSelected: boolean
  style: CSSProperties
}) {
  const { account } = useWeb3React()
  const { t } = useTranslation()
  const key = currencyKey(currency)
  const selectedTokenList = useCombinedActiveList()
  const isOnSelectedList = isTokenOnList(selectedTokenList, currency)
  const customAdded = useIsUserAddedToken(currency)
  const balance = useCurrencyBalance(account ?? undefined, currency)
  const [symobj, setSymobj] = useState(null) // 需要传递的item, 当前
  // only show add or remove buttons if not on selected list

  // MultiChain发行的资产,需要做处理
  const symbolArray = [
    '0xfA9343C3897324496A05fC75abeD6bAC29f8A40f',
    '0x922D641a426DcFFaeF11680e5358F34d97d112E1',
    '0xeFAeeE334F0Fd1712f9a8cc375f427D9Cdd40d73',
    '0x765277EebeCA2e31912C9946eAe1021199B39C61',
    '0x818ec0A7Fe18Ff94269904fCED6AE3DaE6d6dC0b',
    '0x461d52769884ca6235B685EF2040F47d30C94EB5',
  ]
  const handleGoSelect = async (data) => {
    // console.log('选择币种啊', data)
    // onCurrencySelect(data)
  }
  const [onPresentTipsModal] = useModal(
    <TipsModal handleGoSelect={handleGoSelect} symbolData={symobj} />,
    true,
    true,
    'tipsModal',
  )
  useEffect(() => {
    if (symobj !== null) {
      onPresentTipsModal()
    }
  }, [symobj])

  const openModalWithItem = (item) => {
    // console.log(item, '99999')
    setSymobj(item)
  }
  return (
    <MenuItem
      style={style}
      className={`token-item-${key}`}
      onClick={() => (isSelected ? null : onSelect())}
      disabled={isSelected}
      selected={otherSelected}
    >
      <CurrencyLogo currency={currency} size="24px" />
      <Column>
        {symbolArray.includes(currency.address) ? (
          <div>
            <Text bold>
              {currency.symbol}{' '}
              <img
                src="/images/small-img/warning.png"
                alt=""
                width={16}
                onClick={(e) => {
                  e.stopPropagation() // 停止事件传播，阻止触发 MenuItem 的 onClick
                  openModalWithItem(currency)
                }}
              />
            </Text>
            <Text color="textSubtle" small ellipsis maxWidth="200px">
              {!isOnSelectedList && customAdded && `${t('noah115')} •`} {currency.name || ''}
              &nbsp;by Multichain
            </Text>
          </div>
        ) : (
          <div>
            <Text bold>{currency.symbol}</Text>
            <Text color="textSubtle" small ellipsis maxWidth="200px">
              {!isOnSelectedList && customAdded && `${t('noah115')} •`} {currency.name || ''}
            </Text>
          </div>
        )}
      </Column>
      <RowFixed style={{ justifySelf: 'flex-end' }}>
        {balance ? <Balance balance={balance} /> : account ? <CircleLoader /> : null}
      </RowFixed>
    </MenuItem>
  )
}

export default function CurrencyList({
  height,
  currencies,
  inactiveCurrencies,
  selectedCurrency,
  onCurrencySelect,
  otherCurrency,
  fixedListRef,
  showEOS,
  showImportView,
  setImportToken,
  breakIndex,
}: {
  height?: number | string
  currencies: Currency[]
  inactiveCurrencies: Currency[]
  selectedCurrency?: Currency | null
  onCurrencySelect: (currency: Currency) => void
  otherCurrency?: Currency | null
  fixedListRef?: MutableRefObject<FixedSizeList | undefined>
  showEOS: boolean
  showImportView: () => void
  setImportToken: (token: Token) => void
  breakIndex: number | undefined
}) {
  const native = useNativeCurrency()

  const itemData: (Currency | undefined)[] = useMemo(() => {
    let formatted: (Currency | undefined)[] = showEOS
      ? [native, ...currencies, ...inactiveCurrencies]
      : [...currencies, ...inactiveCurrencies]
    if (breakIndex !== undefined) {
      formatted = [...formatted.slice(0, breakIndex), undefined, ...formatted.slice(breakIndex, formatted.length)]
    }
    return formatted
  }, [breakIndex, currencies, inactiveCurrencies, showEOS, native])

  const { chainId } = useActiveWeb3React()

  const { t } = useTranslation()

  const Row = useCallback(
    ({ data, index, style }) => {
      const currency: Currency = data[index]
      const isSelected = Boolean(selectedCurrency && currency && selectedCurrency.equals(currency))
      const otherSelected = Boolean(otherCurrency && currency && otherCurrency.equals(currency))
      const handleSelect = () => onCurrencySelect(currency)

      const token = wrappedCurrency(currency, chainId)

      const showImport = index > currencies.length

      // if (index === breakIndex || !data) {
      //   return (
      //     <FixedContentRow style={style}>
      //       <LightGreyCard padding="8px 12px" borderRadius="8px">
      //         <RowBetween>
      //           <Text small>{t('Expanded results from inactive Token Lists')}</Text>
      //           <QuestionHelper
      //             text={t(
      //               "Tokens from inactive lists. Import specific tokens below or click 'Manage' to activate more lists.",
      //             )}
      //             ml="4px"
      //           />
      //         </RowBetween>
      //       </LightGreyCard>
      //     </FixedContentRow>
      //   )
      // }

      if (showImport && token) {
        return (
          <ImportRow style={style} token={token} showImportView={showImportView} setImportToken={setImportToken} dim />
        )
      }
      return (
        <CurrencyRow
          style={style}
          currency={currency}
          isSelected={isSelected}
          onSelect={handleSelect}
          otherSelected={otherSelected}
        />
      )
    },
    [selectedCurrency, otherCurrency, chainId, currencies.length, onCurrencySelect, showImportView, setImportToken],
  )

  const itemKey = useCallback((index: number, data: any) => currencyKey(data[index]), [])

  return (
    <FixedSizeList
      height={height}
      ref={fixedListRef as any}
      width="100%"
      itemData={itemData}
      itemCount={itemData.length}
      itemSize={56}
      itemKey={itemKey}
    >
      {Row}
    </FixedSizeList>
  )
}
